import { jsx as e, jsxs as c } from "react/jsx-runtime";
import n from "./faq-block.module.less.js";
import { Accordion as h } from "../../elements/accordion/accordion.js";
import { Heading as p } from "../../elements/heading/heading.js";
const d = ({ heading: t, text: s, content: o, items: i, index: l, isBlock: r }) => {
  const m = i.map((a) => ({
    id: a.title,
    heading: a.title,
    open: a.open ?? !1,
    content: a.body ? /* @__PURE__ */ e(
      "div",
      {
        className: [n.accordionItemBody, "html-content"].join(" "),
        dangerouslySetInnerHTML: { __html: a?.body }
      }
    ) : a.text
  }));
  return /* @__PURE__ */ e("div", { className: n.contentWrapper, children: /* @__PURE__ */ c("div", { className: n.innerContentWrapper, children: [
    /* @__PURE__ */ e(
      p,
      {
        index: r ? l : void 0,
        semanticType: r ? "h2" : "h3",
        visualType: r ? "h3" : "h4",
        className: "heading-max-width",
        children: t
      }
    ),
    (o || s) && /* @__PURE__ */ c("div", { className: "body-base text-max-width", children: [
      o && /* @__PURE__ */ e(
        "div",
        {
          className: [n.content, "html-content"].join(" "),
          dangerouslySetInnerHTML: { __html: o }
        }
      ),
      s && s
    ] }),
    /* @__PURE__ */ e("div", { className: "text-max-width", children: /* @__PURE__ */ e(h, { isBlock: r, items: m }) })
  ] }) });
}, y = (t) => /* @__PURE__ */ e("section", { className: n.section, children: /* @__PURE__ */ e("article", { className: `max-width padded-sides ${n.innerWrapper}`, children: /* @__PURE__ */ e(d, { ...t, isBlock: !0 }) }) }), f = (t) => /* @__PURE__ */ e("div", { className: n.contentBlockWrapper, children: /* @__PURE__ */ e(d, { ...t, isBlock: !1 }) });
export {
  y as FaqBlock,
  f as FaqBlockContent,
  y as default
};
